<template>
    <header class="header">
        <div class="header__inner">
            <button v-if="$route.path !== '/main'" class="nav-btn"><img src="@/assets/resource/icon/arrow-left_thin.png" alt="뒤로가기" @click="goBack" /></button>
            <div class="header-left">
                <img v-if="$route.path === '/main'" class="logo" src="@/assets/resource/icon/MEDIVER CI.png" alt="MEDIVER" style="width: 150px; height: auto;"/>
                <span class="page-title">{{ title }}</span>
            </div>
            <div class="profile-box">
                <!-- 홈 버튼 (공통) -->
                <button class="profile-avatar" @click="goHome" v-if="$route.path !== '/main'" >
                    <img src="../../assets/resource/icon/home-1_duotone 2.png" alt="홈" />
                </button>
                <div class="profile-dropdown-wrap">
                    <img src="../../assets/resource/icon/user 2.png" alt="아이콘" @click="toggleDropdown" style="cursor:pointer" ref="profileDropdownIcon"/>
                    <div v-show="dropdownOpen" class="profile-info-box" ref="profileInfoBox">
                        <div class="profile-title">사용자 정보</div>
                        <div class="profile-name">
                            <span>이름</span>
                            <span>{{ authStore.getUser?.name || '' }}</span>
                        </div>
                        <div class="profile-email">
                            <span>계정</span>
                            <span>{{ authStore.getUser?.email || '' }}</span>
                        </div>
                        <div v-if="version !== 'web'" class="app-version">
                            <span>앱 버전 정보</span>
                            <span>v.{{ version }}</span>
                        </div>
                        <div v-if="version !== 'web'" class="app-version">
                            <span>펌웨어 버전 정보</span>
                            <span>v.{{ version }}</span>
                        </div>
                        <button class="pw-change-btn" @click="pwChange()">비밀번호 변경</button>
                        <button class="logout-btn" @click="logout">로그아웃</button>
                        <button class="logout-btn" @click="deleteAccount">회원탈퇴</button>
                    </div>
                </div>
                <!-- 연결됨 표시 -->
                <span class="icon-item" :class="(bleState.deviceConnected.value && bleState.isReady.value) ? 'is-on' : 'is-off'" @click="bleConnect">
                    <img
                    :src="(bleState.deviceConnected.value && bleState.isReady.value)
                        ? require('@/assets/resource/icon/B_on.png')
                        : require('@/assets/resource/icon/B_off.png')"
                    :alt="(bleState.deviceConnected.value && bleState.isReady.value) ? '연결됨' : '연결 안됨'"
                    />
                </span>
                <!-- BLE연결 시 배터리상태 -->
                <span
                    v-if="bleState.deviceConnected.value && bleState.isReady.value"
                    class="icon-battery"
                    :title="batteryTooltip"
                >
                    <img
                        :src="batteryIconSrc"
                        :alt="batteryTooltip"
                        :class="battery_icon"
                    />
                </span>
            </div>
            <!-- 임시비밀번호 재설정 모달 -->
            <div v-if="showTempPasswordModal" class="modal-overlay">
                <div class="modal-content">
                    <button class="modal-close" @click="closeTempPasswordModal">×</button>
                    <!-- TempPassword 컴포넌트 호출 -->
                    <ChangPassword
                        @toLogin="closeTempPasswordModal"
                        :email="authStore.getUser.email"
                        @status="getFlag"
                    />
                </div>
            </div>
        </div>
    </header>
</template>
<script>
    import { ref, inject, onMounted, onBeforeUnmount, computed, watch }  from 'vue'
    import { useRouter } from 'vue-router';
    import axios from 'axios'
    import { useAuthStore }  from '@/stores/auth';
    import ChangPassword     from "@/components/common/ChangPassword.vue";
    import { useAppAlert }   from '@/composables/useAppAlert'
    import { getAppVersion } from '@/utils/appInfo';
    import { useBatteryStore } from '@/stores/battery'

    import batteryCharging from '@/assets/resource/svg/charging_battery.svg'
    import batteryFull     from '@/assets/resource/svg/full_battery.svg'
    import battery70       from '@/assets/resource/svg/70_battery.svg'
    import battery50       from '@/assets/resource/svg/50_battery.svg'
    import battery30       from '@/assets/resource/svg/30_battery.svg'
    import batteryEmpty    from '@/assets/resource/svg/empty_battery.svg'

    export default {
        name: 'Header',
        components: {ChangPassword},
        data() {
            return {
                showTempPasswordModal: false,
            }
        },
        props: {
            title       : { type: String, required: true },
            filterKey   : { type: String, default: null },
            pageKey     : { type: String, default: null }
        },
        setup(props, { emit }) {
            const router = useRouter()
            // BLE 상태 주입
            const bleState               = inject('bleState')
            const bleActions             = inject('bleActions')
            const dropdownOpen           = ref(false)
            const authStore              = useAuthStore();
            const { showAlert, confirm } = useAppAlert()

            const batteryStore = useBatteryStore()


            // 배터리 상태값 
            const batteryPercent = ref(0)
            const chargeStatus   = ref(0x00)

            const BATTERY_ICON_MAP = {
                charging: batteryCharging,
                0x01: batteryFull,
                0x02: battery70,
                0x03: battery50,
                0x04: battery30,
                0x05: batteryEmpty
            }

            const prescriptionRunning = ref(false)

            const version = ref('web')

            const onPrescriptionRunning = (e) => {
                const running = !!(e?.detail?.running)
                prescriptionRunning.value = running
            }

            const bleConnect = () => {
                bleActions.connectDevice()
            }

            // const isCharging = computed(() => chargeStatus.value === 0x10)

            // 충전 상태 텍스트 
           const currentChargeStatus = computed(() => {
                return Number(bleState?.chargeStatus?.value ?? chargeStatus.value ?? 0)
            })

            const chargeStatusText = computed(() => {
                if (currentChargeStatus.value === 0x10) {
                    return '충전 중'
                } else if (currentChargeStatus.value === 0x01) {
                    if (batteryPercent.value === 0x01) return 'FULL BATTERY'
                    if (batteryPercent.value === 0x02) return '70%'
                    if (batteryPercent.value === 0x03) return '50%'
                    if (batteryPercent.value === 0x04) return '30%'
                    if (batteryPercent.value === 0x05) return 'EMPTY BATTERY'
                }
                return ''
            })

            const batteryTooltip = computed(() => {
                return `${chargeStatusText.value}`
            })

            const batteryIconSrc = computed(() => {
                if (currentChargeStatus.value === 0x10) return BATTERY_ICON_MAP.charging
                if (currentChargeStatus.value === 0x01) return BATTERY_ICON_MAP[batteryPercent.value] || batteryEmpty
                return batteryFull
            })

            
            const parseBatteryPacket = (data) => {

                if (!data || data.length < 5) return false
                if (data[0] !== 0x78) return false
                if (data[1] !== 0x0A) return false
                
                // 예시 프로토콜
                // data[1] = 0x0A
                // data[2] = 충전 상태(0x10: 전원 아답터, 0x01: 배터리 모드)
                // data[3] = 배터리 상태(0x00: 충전중, 0x10: low battery, 0x11: empty battery, 0x12: 배터리 동작중)
                // data[4] = 배터리 용량(%) 0x01: Full, 0x02: 70%, 0x03: 50%, 0x04: 30%, 0x05: empty
                // if (data[1] !== 0x0A) return false

                let status  = Number(data[2])
                let percent = Number(data[4])

                chargeStatus.value = status
                // isCharging.value = status
                batteryPercent.value = percent

                if (bleState?.chargeStatus?.value !== undefined) {
                    bleState.chargeStatus.value = status
                }
                if (bleState?.isCharging?.value !== undefined) {
                    bleState.isCharging.value = (status === 0x10)
                }

                batteryStore.setBatteryInfo(status, percent)

                return true
            }

            const handleBleDataReceived = (event) => {
                const data = event?.detail

                if (!data) return
                if (!Array.isArray(data) && !(data instanceof Uint8Array)) return

                const parsed = parseBatteryPacket(data)

                if (parsed) {
                    window.dispatchEvent(new CustomEvent('battery-status-changed', {
                        detail: {
                            chargeStatus: chargeStatus.value,
                            batteryPercent: batteryPercent.value,
                            isCharging: chargeStatus.value === 0x10
                        }
                    }))
                }
            }

            onMounted(() => {
                window.addEventListener('prescription-running', onPrescriptionRunning)
                window.addEventListener('ble-data-received', handleBleDataReceived)

                ;[
                    batteryCharging,
                    batteryFull,
                    battery70,
                    battery50,
                    battery30,
                    batteryEmpty
                ].forEach((src) => {
                    const img = new Image()
                    img.src = src
                })

                version.value = getAppVersion()
            })

            onBeforeUnmount(() => {
                window.removeEventListener('prescription-running', onPrescriptionRunning)
                window.removeEventListener('ble-data-received', handleBleDataReceived)
            })

            const toggleDropdown = () => {
                dropdownOpen.value = !dropdownOpen.value
            }

            const logout = () => {
                sessionStorage.removeItem('hasShownLoginWarning');  // 경고 표시 초기화
                localStorage.removeItem('autoLogin');
                emit('logout');
                dropdownOpen.value = false;
            }

            const deleteAccount = async () => {
                const ok = await confirm(
                    "회원탈퇴를 진행하시겠습니까?\n탈퇴 시 계정 정보와 이용 기록은 복구할 수 없습니다."
                )

                if (!ok) {
                    dropdownOpen.value = false
                    return
                }

                try {
                    const res = await axios.post('/api/user/deleteAccount', {
                        email: authStore.getUser?.email
                    })

                    if (res.data?.result === 1) {
                        await showAlert('회원탈퇴가 정상적으로 완료되었습니다.')

                        // BLE 연결 해제(함수가 없으면 안전하게 스킵)
                        // try { bleActions?.disconnectDevice?.() } catch (e) {}
                        // 2) 사용자 상태 비우기 (Pinia에 메서드 있으면 호출)
                        authStore.clearUser?.()

                        // 3) 토큰 제거
                        localStorage.removeItem('accessToken')
                        sessionStorage.removeItem('accessToken')
                        localStorage.removeItem('autoLogin')
                        sessionStorage.removeItem('hasShownLoginWarning')

                        emit('logout');

                    } else {
                        showAlert('회원탈퇴 처리에 실패했습니다.')
                    }
                } catch (e) {
                    console.error(e)
                    showAlert('회원탈퇴 중 오류가 발생했습니다.')
                } finally {
                    dropdownOpen.value = false
                }
            }

            return {
                bleState,
                authStore,
                dropdownOpen,
                toggleDropdown,
                logout,
                deleteAccount,
                prescriptionRunning,
                showAlert,
                version,
                bleConnect,

                batteryPercent,
                chargeStatus,
                currentChargeStatus,
                chargeStatusText,
                batteryTooltip,
                batteryIconSrc,

                // isCharging
                
            }
        },
        methods: {
            goHome(){
                if (this.prescriptionRunning) {
                    this.showAlert('검사를 종료한 후 홈으로 이동할 수 있습니다.')
                    return
                }
                this.$router.push('/main');
            },
            goRefresh() {
                const defaultFilter = {
                    searchType: "all",
                    searchText: "",
                    startDate: "",
                    endDate: ""
                };
                sessionStorage.setItem(this.filterKey , JSON.stringify(defaultFilter));
                sessionStorage.setItem(this.pageKey, '1');
                location.reload();
            },
            handleClickOutside(event) {
                // 드롭다운 버튼과 메뉴 바깥을 클릭하면 닫기
                if (this.dropdownOpen) {
                    const dropdownBox = this.$el.querySelector('.profile-info-box');
                    const dropdownIcon = this.$el.querySelector('.profile-dropdown-wrap img');

                    if (
                        dropdownBox && !dropdownBox.contains(event.target) &&
                        dropdownIcon && !dropdownIcon.contains(event.target)
                    ) {
                        this.dropdownOpen = false;
                    }
                }
            },
            pwChange() {
                this.showTempPasswordModal = true;
            },
            closeTempPasswordModal() {
                this.showTempPasswordModal = false;
            },
            getFlag(){
                this.showTempPasswordModal = false
            },
            goBack() {

                const fromPath = this.$router.options.history.state.back

                if (this.prescriptionRunning) {
                    this.showAlert('검사를 종료한 후 이동할 수 있습니다.')
                    return
                }

                if (fromPath && fromPath.startsWith('/patientlist/diagnosticsRun')) {
                    this.$router.push('/patientlist/patientlist')  // 환자목록으로 이동
                } else if(window.history.length > 1) {
                    this.$router.back();
                }
            },
        },
        mounted() {
            document.addEventListener('mousedown', this.handleClickOutside);
        },
        beforeUnmount() {
            document.removeEventListener('mousedown', this.handleClickOutside);
        }
    };
</script>
